/**
 * Study Validation Utilities
 * Helper functions for validating study selections
 */

import type { SelectedStudy } from './studyUtils';
import { isStudyApproved, isStudyAssigned } from './studyUtils';

export interface ValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

/**
 * Validate study selection for assignment/reassignment
 */
export function validateStudySelection(selectedStudies: SelectedStudy[]): ValidationResult {
  // Check if any study has approved report status
  const approvedStudies = selectedStudies.filter(isStudyApproved);

  if (approvedStudies.length > 0) {
    return {
      isValid: false,
      errorMessage:
        'This action cannot be performed on mixed selections. Please choose either Assigned or Unassigned studies.',
    };
  }

  // Check if selection is mixed (some assigned, some unassigned)
  const assignedCount = selectedStudies.filter(isStudyAssigned).length;
  const unassignedCount = selectedStudies.length - assignedCount;

  if (assignedCount > 0 && unassignedCount > 0) {
    return {
      isValid: false,
      errorMessage:
        'This action cannot be performed on mixed selections. Please choose either Assigned or Unassigned studies.',
    };
  }

  return { isValid: true };
}
